/* eslint-disable prettier/prettier */
export const motionGrid = 'w-full grid grid-cols-3 gap-4 max-w-[70rem]';

export const column = 'flex flex-col gap-2';

export const headerBanner = 'relative h-[9.999rem] rounded-t-[1.5rem] rounded-b-[0.625rem]';

export const headerBgMedi = 'bg-[#D9D8FE]';

export const headerBgFactory = 'bg-[#F9FAFB]';

export const categoryTitleBadge =
  'absolute top-4 left-4 text-[0.936rem] leading-[1.566rem] py-1 px-3 text-white font-bold rounded-full';

export const categoryTitleBadgeMedi = 'bg-[#423DF9]';

export const categoryTitleBadgeFactory = 'bg-[#6B7280]';

export const headerImageWrap = 'absolute bottom-0 right-4 w-[17.064rem] h-[9.504rem]';

export const headerImageWrapMedi = 'max-w-[17.125rem] max-h-[9.563rem]';

export const headerImageWrapFactory = 'max-w-[8.625rem] max-h-[8.438rem]';

export const list = 'flex flex-col gap-2.5';

export const listItem = 'flex items-center justify-start gap-3 py-6 pl-6 pr-8 rounded-lg';

export const listIcon = 'relative w-[1.503rem] h-[1.503rem]';

export const listIconImg = 'w-full h-full';

export const listTypography = 'text-[1.25rem] leading-[150%]';

export const listTypographyMedi = 'font-bold text-[#111619]';

export const listTypographyFactory = 'font-medium text-[#6B7280]';

export const highlight = 'text-[#423DF9]';
